export const NULL_BODY_STATUS = [101, 103, 204, 205, 304];
